import AddIcon from '@mui/icons-material/Add'
import { Button } from '@mui/material'

import { TableToolbarProps } from '@/components'
import { addNewRow } from '@/components/NewTable'
import { useDetailTabContext } from '@/pages/User/pages/Home/components/DetailTab'

export const TableToolbar = <T extends object>({
	customButtons,
	newRowPayload = {} as T,
	updateTableData,
	isCustomAddNew,
	customAddNew,
	setSelectedRow,
	dynamicUuidProp,
	tableInstance,
	rowVirtualizerRef,
}: TableToolbarProps<T>) => {
	const {
		state: { editMode },
	} = useDetailTabContext()

	const defaultAddNew = () =>
		addNewRow<T>({
			updateTableData,
			newRowPayload,
			setSelectedRow,
			dynamicUuidProp,
			tableInstance,
			rowVirtualizerRef,
		})

	return (
		<section className="flex items-center pt-4 gap-4">
			<Button
				onClick={isCustomAddNew ? () => customAddNew?.(true) : defaultAddNew}
				startIcon={<AddIcon />}
				disabled={!editMode}
				variant="contained"
				color="primary"
				data-testid="table-toolbar-button-add"
			>
				New
			</Button>
			{customButtons ? customButtons : <></>}
		</section>
	)
}
